<div class="left-part">
  <i class="pp-icon-back back" (click)="backClickHandler()"></i>

  <i [class]="iconClass" *ngIf="iconClass"></i>

  <div class="title">{{titleWithoutTranslation ? titleWithoutTranslation : (titleToTranslate | cpTitleTranslate | async)}}</div>
</div>

<div class="right-part">
  <div class="vertical-separator"></div>

  <i class="pp-icon-cancel close" (click)="closeClickHandler()"></i>
</div>

<ng-template #closePopupTitle>
  <div class="popup-title-container page-header">
    <div class="popup-title-text">{{"CloseVerification" | cpTitleTranslate | async}}</div>
    <i class="pp-icon-close popup-close" (click)="popupWindowService.closeLatestPopup(false)"></i>
  </div>
</ng-template>

<ng-template #closePopupContent>
  <div class="popup-content-container page-header">
    <div class="question-container">
      <i class="pp-icon-error"></i>
      <div class="question-text">
        <strong>{{"AreYouSure" | cpTitleTranslate | async}}?</strong>
        <br>{{"CloseVerification" | cpMessageTranslate | async }}
      </div>
    </div>

    <div class="popup-footer">
      <cp-button-widget-custom class="link-button" captionToTranslate="CloseVerificationContinue" (onClick)="popupWindowService.closeLatestPopup(false)"></cp-button-widget-custom>
      <cp-button-widget-custom class="primary-button" captionToTranslate="CloseVerificationCancel" (onClick)="popupWindowService.closeLatestPopup(true)"></cp-button-widget-custom>
    </div>
  </div>
</ng-template>
